import { render, staticRenderFns } from "./uploadimg-success-loading.vue?vue&type=template&id=bbcdda38&scoped=true&"
import script from "./uploadimg-success-loading.vue?vue&type=script&lang=js&"
export * from "./uploadimg-success-loading.vue?vue&type=script&lang=js&"
import style0 from "./uploadimg-success-loading.vue?vue&type=style&index=0&id=bbcdda38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcdda38",
  null
  
)

export default component.exports